// extracted by mini-css-extract-plugin
export default {"container":"Testimonial_container__wXtCR","itemTitle":"Testimonial_itemTitle__bY0QB","item":"Testimonial_item__q9JCs"};